import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const DollarIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 18",
    fill: "currentColor",
    width: size || '10',
    height: size || '18'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.82 18c.083 0 .163-.077.163-.152v-1.593c0-.077.083-.152.164-.152 1.148-.152 2.13-.532 2.788-1.139.738-.683 1.065-1.518 1.065-2.657s-.327-1.974-1.065-2.583c-.738-.607-1.803-1.215-3.362-1.747-.82-.304-1.393-.607-1.64-.912-.327-.304-.49-.684-.49-1.216 0-.532.163-.912.41-1.216.247-.303.738-.455 1.312-.455.574 0 .984.229 1.312.607.327.38.491.912.491 1.519 0 .077.083.229.247.229h2.46c.164 0 .247-.077.247-.229v-.077c0-1.139-.328-2.05-.985-2.734-.655-.76-1.559-1.216-2.624-1.367-.083 0-.164-.077-.164-.152L6.147.152C6.147.075 6.064 0 5.983 0H4.671c-.083 0-.163.077-.163.152v1.747c0 .077-.083.152-.164.152-1.148.151-2.13.532-2.788 1.215C.82 3.95.491 4.786.491 5.85c0 1.139.328 2.05 1.065 2.658.738.606 1.887 1.215 3.362 1.67.738.303 1.312.607 1.64.912.327.304.49.76.49 1.216 0 .532-.163.912-.49 1.215-.328.304-.821.455-1.393.455-.655 0-1.148-.151-1.559-.532-.41-.38-.574-.912-.655-1.67 0-.077-.083-.152-.163-.152H.164c-.083 0-.164.077-.164.152v.38c.083 1.139.491 2.05 1.229 2.658.82.683 1.803 1.138 3.034 1.215.083 0 .164.077.164.152v1.596c-.083.151 0 .226.08.226H5.82z",
    fillRule: "evenodd"
  }));
};
DollarIcon.displayName = 'DollarIcon';
export default DollarIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DollarIcon.js.map